
import * as React from 'react';
import profilehtml from '../assets/profilehtml.jpg';
//import { Typography } from '@mui/material';

export default function About() {
  return (
   
<div>
<p>ABOUT ME</p>
<div>
      <img src={profilehtml} alt="me" height="350" width="300"/>
    </div>



    <p> Web Developer with a background in Customer Service. Recognized as a proactive, persistent problem-solver, resourceful,<br/>
      collaborative, and as well, excellent communicator with practical client relationship-building skills. I acquired a<br/>
      certificate in Full-Stack Development from the Penn LPS Coding Boot Camp. I developed skills in JavaScript, CSS, React,<br/>
      MySQL, and third-party APIs in Bootcamp. I graduated Magna Cum Laude with a bachelor’s degree in Computer Science. I have <br/>
      worked on a team on many occasions to develop viable full-stack applications in only two weeks. As a team, we created an <br/>
      easy-to-navigate and intuitive user experience. It brings me joy to create alongside a team a user interface that is clean,<br/>
      polished, and easy to navigate. </p>


</div>
   
  );
}
